import log from 'loglevel'
import axios, { type AxiosHeaders } from 'axios'
import { isNil } from 'lodash/fp'

import { url, getCustomHeaders } from 'components/DataProvider/functions'

log.setLevel(log.levels.DEBUG)

export const doExecute = async (
  id: string,
  target: string
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const headers = getCustomHeaders() as AxiosHeaders | undefined
  if (isNil(headers)) return undefined
  const methods = {
    cognito: { url: `${url}/cognito/users/${id}`, method: 'delete' },
    changeContact: {
      url: `${url}/changeContact/${id}`,
      method: 'post',
      data: {}
    },
    editOrganizations: {
      url: `${url}/editOrganizations/${id}`,
      method: 'post',
      data: {}
    },
    editAccounts: { url: `${url}/cognito/users/${id}`, method: 'delete' }
  }
  const method = methods[target]
  if (isNil(method)) return undefined
  const { status } = await axios.request({
    ...method,
    headers: { Authorization: headers.get('Authorization') }
  })
  return status
}
